import React from "react";
import TextInput from "../../../TextInput";
import {saveChangesEvent} from "../../../../../utils/events";
import config from "../../../../../config/config";
import {FilterProps} from "./Filter";

export default class DefaultFilter<Props extends FilterProps = any, State extends any = any> extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            value: this.props.filter?.value
        } as any;
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (
            this.props.filter?.value !== prevProps.filter?.value && this.props.filter?.value !== undefined
            ||
            this.props.filterOpened !== prevProps.filterOpened
        ) {
            this.setState({
                value: this.props.filter?.value
            })
        }
    }

    render() {
        let filter = this.props.filter || {field: this.props.filterField || this.props.field, value: null, operator: this.props.filterOperator || "LIKE"};
        return (
            <TextInput
                label={false}
                value={this.state.value}
                focus={true}
                saveChanges={saveChangesEvent((event) => {
                    let value = event.value;
                    this.setState({value});
                    if (filter.operator === "LIKE" && (value || "").length >= config.minimumLengthOfSearch) {
                        this.props.setFilter({...filter, value: value.trim()});
                    } else if(filter.operator === "=" && value !== null && value !== undefined && value.trim() !== '') {
                        this.props.setFilter({...filter, value: value.trim()});
                    } else {
                        this.props.setFilter(undefined);
                    }
                })}
            />
        );
    }
}